<div class="widget-data">
  <div class="container">
    <div class="d-flex">
      <img
        src="assets/images/nafath-verification/nafath-verification-succeeded.svg"
        alt="nafath verification succeeded"
        class="nafath-verification-succeeded"
      />
    </div>

    <h1>{{ "your-request-has-been-submitted-successfully" | translate }}</h1>
  </div>
</div>
